<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '增加' : '减少') + '订单'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="1000px"
  >
    <section class="dialogContent" v-loading="getDetailLoading">
      <qx-search-box
        class="searchBox"
        ref="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        :inDialog="true"
        permpisionsQuery=""
      />
      <TableBox ref="tableBox" />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="post" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  customerBillAddOrder,
  customerBillDelOrder,
} from 'api/getPay';
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      searchBoxData: {
        form: [
          { // 发车时间
            label: '发车时间',
            value: 'departTime',
            type: 'date',
            placeholder: '请输入发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 客户单号
            label: '客户单号',
            value: 'customNumber',
            type: 'input',
            placeholder: '请输入客户单号',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @param {String} type 类型
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item, type) {
      this.dialogFormVisible = true; // 打开弹窗
      this.type = type;
      this.originData = item;
      this.$nextTick(() => {
        this.$refs.searchBox.sub();
      });
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 发车时间
      if (searchBoxData.Time) {
        searchBoxData.beginTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
        delete searchBoxData.Time;
      }
      this.$refs.tableBox.saveSearchBoxData({
        billNumber: this.type === 'add' ? null : this.originData.billNumber,
        customName: this.type === 'add' ? this.originData.customName : null,
        isAddBill: this.type === 'add',
        ...searchBoxData,
      });
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async post (form) {
      const orderIds = this.$refs.tableBox.tableData.selectResult.map((item) => item.orderId);
      if (orderIds.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      if (this.type === 'del' && Number(this.$refs.tableBox.tableData.total) === orderIds.length) {
        this.$message.warning('不可减少所有的订单，如需减少所有订单，请操作[撤销]账单操作。');
        return;
      }
      this.subLoading = true;
      let res;
      if (this.type === 'add') {
        res = await customerBillAddOrder({
          billNumber: this.originData.billNumber,
          orderIds: orderIds.join(','),
        });
      } else {
        res = await customerBillDelOrder({
          billNumber: this.originData.billNumber,
          orderIds: orderIds.join(','),
        });
      }
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dialogContent{
  padding-bottom: 24px;
}
.searchBox{
  ::v-deep .customForm{
    margin: 0;
  }
}
</style>
